import React from 'react';
import { useDispatch } from 'react-redux';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { alpha, lighten, styled } from '@mui/material/styles';

import { setSelectedFlow } from '../../../../../actions/casesActions';

import {
  procedureFlows,
  selectedProcedureFlows,
} from '../../../../../constants/cases';

import vilex_h2_image from '../../../../../assets/step0/PS_Vilex_Hintermann_H2.png';
import vilex_h3_image from '../../../../../assets/step0/PS_Vilex_Hintermann_H3.png';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,

  '& .block-header': {
    width: '90%',
    marginTop: 10,
    marginBottom: 25,
  },
}));

const StyledListItem = styled(ListItem)(({ selected, theme }) => ({
  borderRadius: 20,
  border: '2px solid #BD1435',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  backgroundColor: selected
    ? `${theme.palette.mode === 'dark'
      ? alpha('#BD1435', 0.32)
      : lighten('#BD1435', 0.95)} !important`
    : 'var(--color-surface)',
  '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
    color: selected
      ? (theme.palette.mode === 'dark' ? theme.palette.text.primary : undefined)
      : undefined,
  },
  '& img': {
    filter: selected && theme.palette.mode !== 'dark' ? 'brightness(1.05) contrast(1.05)' : 'none',
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    fontSize: '1.2rem',
    fontWeight: 600,
    letterSpacing: 1.5,
    color: theme.palette.text.primary,
  },
  '& .MuiListItemText-secondary': {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
}));

export const Step0Vilex = ({ selected, onChange, procedures = [] }) => {
  const dispatch = useDispatch();

  const handleProcedureFlowClick = (event, flow) => {
    onChange(flow);
    dispatch(setSelectedFlow(flow));
  };

  return (
    <Container>
      <div className="block-header">Select Procedure</div>

      <Grid container aria-label="procedures" sx={{ width: '95%' }} spacing={3}>
        {procedures.some((procedure) =>
          [
            procedureFlows.VILEX,
            procedureFlows.VILEX_H2,
            procedureFlows.VILEX_H3,
          ].includes(procedure.flow)
        ) && (
          <>
            {procedures.some(
              (procedure) => procedure.flow === procedureFlows.VILEX_H2
            ) && (
              <Grid item size={{ xs: 12, md: 6 }}>
                <StyledListItem
                  button
                  selected={selected === selectedProcedureFlows.VILEX_H2}
                  onClick={(event) =>
                    handleProcedureFlowClick(
                      event,
                      selectedProcedureFlows.VILEX_H2
                    )
                  }
                >
                  <img
                    src={vilex_h2_image}
                    alt="VILEX_H2"
                    width="80"
                    height="80"
                  />
                  <StyledListItemText
                    primary="H2 "
                    secondary="Patient Specific Instrumentation"
                  />
                </StyledListItem>
              </Grid>
            )}

            {procedures.some(
              (procedure) => procedure.flow === procedureFlows.VILEX_H3
            ) && (
              <Grid item size={{ xs: 12, md: 6 }}>
                <StyledListItem
                  button
                  selected={selected === selectedProcedureFlows.VILEX_H3}
                  onClick={(event) =>
                    handleProcedureFlowClick(
                      event,
                      selectedProcedureFlows.VILEX_H3
                    )
                  }
                >
                  <img
                    src={vilex_h3_image}
                    alt="VILEX_H3"
                    width="80"
                    height="80"
                  />
                  <StyledListItemText
                    primary="H3 HINTERMANN"
                    secondary="Patient Specific Instrumentation"
                  />
                </StyledListItem>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Container>
  );
};
